var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"list-search-container"},[_c('div',{staticClass:"search-input"},[_c('input',{attrs:{"placeholder":"输入关键词搜索"},domProps:{"value":_vm.value},on:{"input":_vm.handleInput}}),_c('div',{staticClass:"icon",on:{"click":_vm.handleSearch}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }